module.exports = __webpack_public_path__ + "home-background.1MqqYxLx.svg";